<template>
	<div>
		<!-- <v-card-actions>			
			<v-spacer></v-spacer>	
			<v-btn color="warning" @click="downloadWithCSS">
				<v-icon>cloud_download</v-icon> PDF
			</v-btn>			
			<v-btn color="info" @click="exportTableToExcel('tblData', 'members-data')">
				<v-icon>description</v-icon> Excel
			</v-btn>
		</v-card-actions> -->

		<v-toolbar
		dark
		fixed
		app
		height="50"
		class="toolBar"
		>
		<v-spacer></v-spacer>

		<v-toolbar-items>
			<v-icon class="white--text" @click="downloadWithCSS('DesignatedAccountActivityStatement')">cloud_download</v-icon>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<v-icon class="white--text" @click="printdiv">print</v-icon>
		</v-toolbar-items>
	</v-toolbar>

 <!-- {{items}} -->

<v-container grid-list-md :class="{opacityC:isTrue}">
	<v-layout wrap>
		<v-flex xs10 offset-xs1>
			<div style="background:#FFF; padding:20px;">
				<div ref="content" id="print_div">				
					<table class="reportTbl" width="100%" id="tblData">	
						<tbody>
							<tr class="tb-td">
								<td colspan="5" style="
												    text-align: left;
												    font-weight: normal;
												    font-size: 11px;
												">
								Interim Un-audited Financial Report(IUFR)</td>
							</tr>
							<tr class="tb-td">
								<td colspan="5">
								<!-- Investment Promotion &amp; Financing Facility I (IPFF I) Project -->	
								{{ (items.length>0)? items[0].project_name : ""}}							
								</td>
							</tr>
							<tr class="tb-td">
								<td colspan="5">International Development Association</td>
							</tr>
							<tr class="tb-td">
								<td colspan="5">1D, Designated Account (DA) Activity Statement</td>
							</tr>
							<tr class="tb-td">
								<td colspan="5">For the reporting Quater</td>
							</tr>
							<tr class="tb-td">
								<td colspan="5" style="text-align: right;font-weight: normal;">Amount in USD</td>
							</tr>
							<tr>
								<td class="textCenter">SL NO</td>
								<td>Description</td>
								<td class="textCenter">Amount Credit A</td>
								<td class="textCenter"> Amount Credit B</td>
								<td class="textCenter">Total</td>
							</tr>
							<tr v-for="item in items">
								<td class="textCenter">{{item.ID}}</td>
								<td>{{item.particuler}}</td>
								<td class="textRight">{{item.credit_a}}</td>
								<td class="textRight">{{item.credit_b}}</td>
								<td style="text-align:right;">{{item.credit_b + item.credit_b}}.00</td>
							</tr>							
						</tbody>
					</table>
				</div>
			</div>
		</v-flex>
	</v-layout>
</v-container> 


</div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"
const commonService = require("../../../services/common.service");
export default {
	props:['paramVal'],
	data: () => ({
		
		items:[],
		subItems:[],
		isTrue:false,
		
	}),

	created(){		
		//console.log('created');
		this.getData();
	},

	watch: {
		paramVal() {
			this.getData();
		}
	},

	methods: {

		getData(){

			let root = this;
			let formSchema = '';
			let p = this.paramVal;
			
			if(typeof p == "undefined")
			{
				this.isTrue = false;
				formSchema = JSON.parse(sessionStorage.getItem('report'));
			}
			else
			{
				this.isTrue = true;
				formSchema = this.paramVal;
			}
			
			/*let formSchema = {
				'project_id': 1,
				'report_type': 1,
			}*/

			commonService.dataByMulParameters(formSchema, "designated-act-statement").then(res => {
				//console.log('res', res);
				if(res)
				{
					if(res.mainQueryData.length>0)
					{
						this.items = res.mainQueryData
					}

					/*if(res.querySub.length>0)
					{
						this.subItems = res.querySub
					}*/

					/*if(formSchema.report_type == 1)
					{
						this.downloadWithCSS('Monthly-Progress-Report');
					}
					else
						*/

					if(formSchema.report_type == 0)
					{	
						setTimeout(function(){							
							root.exportTableToExcel('tblData', 'Monthly-Progress-Report');
						},1000);							
					}					
				}

			});
		},

		downloadWithCSS(filename='') 
		{
	       var quotes = document.getElementById('print_div');
	       html2canvas(quotes).then((canvas) => {
	            //! MAKE YOUR PDF
	            var pdf = new jsPDF('p', 'pt', 'letter');	  


	            for (var i = 0; i <= quotes.clientHeight/980; i++) {
	                //! This is all just html2canvas stuff
	                var srcImg  = canvas;
	                var sX      = 0;
	                var sY      = 980*i; // start 980 pixels down for every new page
	                var sWidth  = 900;
	                var sHeight = 1000;
	                var dX      = 0;
	                var dY      = 0;
	                var dWidth  = 900;
	                var dHeight = 980;

	                window.onePageCanvas = document.createElement("canvas");
	                onePageCanvas.setAttribute('width', 900);
	                onePageCanvas.setAttribute('height', 980);
	                var ctx = onePageCanvas.getContext('2d');
	                // details on this usage of this function: 
	                // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
	                ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);

	                // document.body.appendChild(canvas);
	                var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

	                var width         = onePageCanvas.width;
	                var height        = onePageCanvas.clientHeight;

	                //! If we're on anything other than the first page,
	                // add another page
	                if (i > 0) {
	                    pdf.addPage(); //8.5" x 11" in pts (in*72)
	                }
	                //! now we declare that we're working on that page
	                pdf.setPage(i+1);
	                //! now we add content to that page!
	                pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width*.62), (height*.62));

	            }
	            filename = filename?filename+'.pdf':'pdf-file.pdf';
	            //! after the for loop is finished running, we save the pdf.
	            pdf.save(filename);
	        });      
	    },

		exportTableToExcel: function(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
				var blob = new Blob(['\ufeff', tableHTML], {
					type: dataType
				});
				navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
		}		
	},

	checkDateFormate(){

	},

	printdiv: function () {
		this.printContentStatus = true;
		const divToPrint = document.getElementById("print_div");
		this.printContentStatus = false;
		const newWin = window.open("", "Print-Window");
		newWin.document.open();
		newWin.document.write(
			'<style type="text/css">'+
			'table.reportTbl{width:100%;border-collapse:collapse}.reportTbl td{border:1px solid #ccc;padding:6px}.reportTbl tr td{text-align:left;line-height:15px}.txtRight{text-align:right!important}.reportTbl tr.txtCenter td{text-align:center}.reportTbl tr.tb-td td{font-weight:700;text-align:center;border:none}td.textCenter{text-align:center!important}td.textRight{text-align:right !important}'+
			"</style>"
			);
		newWin.document.write(
			'<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
			divToPrint.innerHTML +
			"</body></html>"
			);

		newWin.document.close();
		setTimeout(function () {
			newWin.close();
		}, 10);
	},

}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table.reportTbl{
	width:100%;
	border-collapse: collapse;
}
.reportTbl td{
	border:1px solid #CCC;
	padding: 6px;
}
.reportTbl tr td{	
	text-align:left;
	line-height: 15px;
}
.txtRight{	
	text-align:right !important;
}
.reportTbl tr.txtCenter td{	
	text-align:center;
}
.reportTbl tr.tb-td td{
	font-weight: bold;
	text-align:center;
	border:none;
}
td.textCenter{
	text-align: center !important;
}
td.textRight{
	text-align: right !important;
}
.subTable tr td{
	/*text-align: center !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/reportGenerate/reportsB/DesignatedAccountActivityStatement.vue